export default __webpack_public_path__ + "static/media/heart.4b84521f.svg";